// This file is generated using scripts/generate-icon-components/utils.js
// Don't edit it manually

import React from 'react';

const IconCustomSort = (
  {
    size,
    style,
    ...rest
  }: React.HTMLAttributes<SVGElement> & { size?: number } /*#__PURE__*/,
) =>
  React.createElement(
    'svg',
    {
      style: { width: size, height: size, ...style },
      ...rest,
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      xmlns: 'http://www.w3.org/2000/svg',
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M3.65658 6.34342L7.72804 2.27196C7.87824 2.12176 8.12176 2.12176 8.27196 2.27196L12.3434 6.34342C12.5857 6.58571 12.4141 7 12.0715 7H8H3.92854C3.58589 7 3.41428 6.58572 3.65658 6.34342Z',
      fill: 'currentColor',
      stroke: 'currentColor',
      strokeWidth: '0.384615',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M12.3434 9.77181L8.27196 13.8433C8.12176 13.9935 7.87824 13.9935 7.72804 13.8433L3.65658 9.77181C3.41429 9.52952 3.58589 9.11523 3.92854 9.11523L8 9.11523L12.0715 9.11523C12.4141 9.11523 12.5857 9.52952 12.3434 9.77181Z',
      fill: 'currentColor',
      stroke: 'currentColor',
      strokeWidth: '0.384615',
    }),
  );

export { IconCustomSort };
